import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import Form, { FormTextField } from '@ts-core/core/components/FormV2';

import { ExternalItemLinkInput } from '../../types';

const ExternalItemLinkFormSchema = Yup.object({
  name: Yup.string().required(),
  url: Yup.string().url().required(),
});

export interface ExternalItemLinkFormProps {
  onSubmit: (data: ExternalItemLinkInput) => void;

  isSubmitting: boolean;
  submitError?: string;
}

const ExternalItemLinkForm = (props: ExternalItemLinkFormProps) => {
  const { onSubmit, isSubmitting, submitError } = props;

  const { handleSubmit, formState, control } = useForm<ExternalItemLinkInput>({
    resolver: yupResolver(ExternalItemLinkFormSchema),
  });

  return (
    <Box width="100%">
      <Form onSubmit={handleSubmit(onSubmit)} isSubmitting={isSubmitting} formState={formState} submitError={submitError}>
        <Stack spacing={2}>
          <FormTextField control={control} name="name" rules={{ required: true }} fullWidth label="Nombre" defaultValue="" />
          <FormTextField control={control} name="url" rules={{ required: true }} fullWidth label="Url" defaultValue="" />
        </Stack>
      </Form>
    </Box>
  );
};

ExternalItemLinkForm.propTypes = {
  isSubmitting: PropTypes.bool,
  submitError: PropTypes.string,

  onSubmit: PropTypes.func,
};

ExternalItemLinkForm.defaultProps = {
  isSubmitting: false,
  submitError: undefined,

  onSubmit() {},
};

export default ExternalItemLinkForm;
